import { useParams, useNavigate } from "react-router-dom";
import { PurchaseOrderDetailPage as PurchaseOrderDetailPageView } from "@/components/PurchaseOrderDetailPage";

export function PurchaseOrderDetailPage() {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();

  if (!id) return null;

  return (
    <PurchaseOrderDetailPageView
      purchaseOrderId={id}
      onBack={() => navigate("/purchase-orders")}
      onMatchClick={(billId) => navigate(`/bills/${billId}/match`)}
      onSupplierClick={(supplierId) => navigate(`/suppliers/${supplierId}`)}
    />
  );
}
